export default [
  {
    path: '/',
    name: 'landing',
    redirect: '/login',
    component: () => import('@/views/Layout.vue'),
    meta: {
    },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/Home.vue'),
    meta: {
      requireAuth: true,
      pageTitle: 'Dashboard',
      breadcrumb: [
        {
          text: 'Dashboard',
          active: true,
        },
      ],
    },
  },
  {
    path: '/transactions',
    name: 'introducer-transactions',
    redirect: 'transactions/payment',
    component: () => import('@/views/introducer/Page.vue'),
    children: [
      {
        path: 'payment',
        name: 'introducer-payment',
        component: () => import('@/views/introducer/payment.vue'),
        meta: {
          requireAuth: true,
          pageTitle: 'Payment',
          breadcrumb: [
            {
              text: 'Payment',
              active: true,
            },
          ],
        },
      },
      {
        path: 'payout',
        name: 'introducer-payout',
        component: () => import('@/views/introducer/payout.vue'),
        meta: {
          requireAuth: true,
          pageTitle: 'Payout',
          breadcrumb: [
            {
              text: 'Payout',
              active: true,
            },
          ],
        },
      },
    ],
  },
  {
    path: '/merchants',
    name: 'introducer-merchants',
    component: () => import('@/views/introducer/reports.vue'),
    meta: {
      requireAuth: true,
      pageTitle: 'Reports',
      breadcrumb: [
        {
          text: 'Reports',
          active: true,
        },
      ],
    },
  },

]
